import BigNumber from 'bignumber.js';

export const displayTokenAmount = (value?: number | string | BigNumber) => {
  if (!value) return '0';
  const result = BigNumber(value);
  if (result.abs().isLessThan(0.1)) return result.toFixed(8);
  if (result.abs().isLessThan(10)) return result.toFixed(4);
  return result.toFixed(2);
}
